import React, { useEffect, useState } from 'react';
import { ImageField, FormField } from '../styleguide';

export default ({
  required,
  name,
  formData: value,
  schema: { title: text, validationMessages, editText, removeText, uploadText, id, displayHelpText, mode, formMapping, action, ids },
  onChange,
  rawErrors,
}) => {
  const handleChange = ({ target: { file, value } }) => {
    //eslint-disable-next-line no-nested-ternary
    onChange(file === '' || file === undefined ? value === '' ? undefined : value : value)
  };
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if(mode === 'compact') {
      // Check if the field is required and value is not present
      if (required && !value)
        setErrorMessage('This field is required');
      else {
        // Otherwise, use the dynamic error message if available
        const errorId = Array.isArray(rawErrors) && rawErrors[0];
        const dynamicErrorMessage = validationMessages ? validationMessages[errorId] : errorId;
        setErrorMessage(dynamicErrorMessage || '');
      }
    }
  }, [required, value, rawErrors, validationMessages]);

  return (
    <FormField error={errorMessage} required={required} value={value}>
      <ImageField
        id={id}
        ids={ids}                
        name={name}
        text={text}
        mode={mode}
        value={value}
        action={action}
        editText={editText}
        removeText={removeText}
        uploadText={uploadText}
        onChange={handleChange}
        formMapping={formMapping}
        displayHelpText={displayHelpText}
      />
    </FormField>
  );
};
